import React from "react";

import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { Button } from "@/uiKit/atoms/Button.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { NURSE_INCLUSION_PATIENT_CREATION_FORM_ID } from "@/uiKit/organisms/PatientCreationAndRenewal/NurseInclusion/NurseInclusionPatientCreationForm.tsx";
import { NurseInclusionPatientCreationInfo } from "@/uiKit/organisms/PatientCreationAndRenewal/NurseInclusion/NurseInclusionPatientCreationInfo.ts";
import { PatientInfo } from "@/uiKit/organisms/PatientCreationAndRenewal/PatientInfo/PatientInfo.ts";

export type NurseInclusionPatientCreationFormActionsProps = {
  onBack: (data: Partial<PatientInfo>) => void;
  className?: string;
};

export const NurseInclusionPatientCreationFormActions: React.FC<NurseInclusionPatientCreationFormActionsProps> = ({
  onBack,
  className,
}) => {
  const { t } = useTranslation();
  const formContext = useFormContext<PatientInfo>();
  const diabetesType = useWatch<NurseInclusionPatientCreationInfo, "diabetesType">({
    name: "diabetesType",
  });
  const insulinScheme = useWatch<NurseInclusionPatientCreationInfo, "insulinScheme">({
    name: "insulinScheme",
  });

  return (
    <CardFooter className={className}>
      <Button
        variant="outlined"
        data-action="patient-creation.nurse-inclusion.cancel"
        id="nurse-inclusion-patient-creation-cancel"
        onClick={() => onBack && onBack(formContext.getValues())}
      >
        {t("button.cancel")}
      </Button>
      <Button
        form={NURSE_INCLUSION_PATIENT_CREATION_FORM_ID}
        id="nurse-inclusion-patient-creation-next"
        type="submit"
        variant="contained"
        data-action="patient-creation.nurse-inclusion.next"
      >
        {t(
          diabetesType === "gestational" && insulinScheme === "noInsulin" ? "diabetesForms.addPatient" : "button.next",
        )}
      </Button>
    </CardFooter>
  );
};
